const ENDPOINT =
  "https://e6i71hxxdg.execute-api.ap-southeast-2.amazonaws.com/dev";

export const emptyRequest = {
  name: "",
  email: "",
  phone: "",
  relation: "",
  addressLine1: "",
  addressLine2: "",
  postCode: "",
  numberOfLots: "",
  comments: "",
};

export function prepareManagementRequest(values) {
  const payload = Object.fromEntries(
    Object.keys(emptyRequest).map((key) => [
      key,
      String(values[key] ?? "").trim(),
    ]),
  );
  payload.email = payload.email.toLowerCase();
  payload.numberOfLots = payload.numberOfLots.replace(/,/g, "");
  const errors = {};
  if (payload.name.length < 2 || payload.name.length > 50)
    errors.name = "Enter your name, between 2 and 50 characters.";
  if (
    payload.email.length > 100 ||
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)
  )
    errors.email = "Enter a valid email address.";
  const phoneDigits = payload.phone.replace(/\D/g, "");
  if (
    !/^[+\d\s()-]+$/.test(payload.phone) ||
    payload.phone.length > 20 ||
    phoneDigits.length < 8 ||
    phoneDigits.length > 15
  )
    errors.phone = "Enter a phone number we can reach you on.";
  if (!["Owner", "Tenant", "Other"].includes(payload.relation))
    errors.relation = "Select your relationship to the property.";
  if (!payload.addressLine1 || payload.addressLine1.length > 100)
    errors.addressLine1 = "Enter the property address, up to 100 characters.";
  if (payload.addressLine2.length > 100)
    errors.addressLine2 = "Keep the second address line under 101 characters.";
  if (!/^[3-9]\d{3}$/.test(payload.postCode))
    errors.postCode = "Enter a valid four-digit postcode.";
  if (!/^[1-9]\d{0,4}$/.test(payload.numberOfLots))
    errors.numberOfLots = "Enter a whole number between 1 and 99,999.";
  if (payload.comments.length > 3000)
    errors.comments = "Keep your message to 3,000 characters or fewer.";
  return { payload, errors };
}

export async function submitManagementRequest(payload, { signal } = {}) {
  const controller = new AbortController();
  const cancel = () => controller.abort();
  signal?.addEventListener("abort", cancel, { once: true });
  if (signal?.aborted) controller.abort();
  const timeout = setTimeout(cancel, 20000);
  try {
    const response = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    if (response.status !== 200)
      throw new Error(
        "We could not send your request. Your details are still here. Please try again or contact us directly.",
      );
  } catch (error) {
    if (error.name === "AbortError")
      throw new Error(
        "We could not confirm your request was received. Please call or email us before sending it again.",
      );
    if (error instanceof TypeError)
      throw new Error(
        "We could not connect. Check your connection and try again, or contact us directly.",
      );
    throw error;
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener("abort", cancel);
  }
}
